// Main authorized roles
const editRoles = [
	'0', // admin
	'1', // manager
];

export default editRoles;
